const ListaHoroscopo = {
    Initialize() {
        const $sectionSignos = document.querySelector('.listaSignos');
        
        if ($sectionSignos === null)
            return;

        let FadeInArticle = (element) => {
            let num = 0;
            Array.from(element).map((item) => {
                item.classList.add("fadeInUp");
                item.style.animationDelay = num + 's';
                num += 0.2;
            });
        };

        const $article = document.querySelectorAll('.listaSignos__item');
        let PANTALLA_ARRIBA = window.pageYOffset;
        let PANTALLA_TAMANIO_Y = window.innerHeight;
        let PANTALLA_BOTTOM = PANTALLA_ARRIBA + PANTALLA_TAMANIO_Y;

        if (PANTALLA_BOTTOM > $sectionSignos.offsetTop) {
            FadeInArticle($article);
        }

        document.addEventListener('scroll', () => {
            PANTALLA_TAMANIO_Y = window.innerHeight;
            PANTALLA_ARRIBA = window.pageYOffset;
            PANTALLA_BOTTOM = PANTALLA_ARRIBA + PANTALLA_TAMANIO_Y;

            if (PANTALLA_BOTTOM > $sectionSignos.offsetTop) {
                FadeInArticle($article);
                return false;
            }
        });
    }
};

export default ListaHoroscopo;


// WEBPACK FOOTER //
// ./Statics/scripts/Modules/ListaHoroscopo.js